export const routingStatusTopicName = (userId?: string) => userId ? `v2.users.${userId}.routingStatus` : undefined;
